import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit, OnChanges {
  @Input() name: string;
  @Input() value: any;
  @Input() disabled: boolean = false;
  @Input() error: string = '';
  @Input() placeHolder: string;
  @Output() dateChanged: EventEmitter<any> = new EventEmitter();

  calendarValue: any;
  loacle: any = {
    firstDayOfWeek: 1,
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"],
    monthNames: [ "January","February","March","April","May","June","July","August","September","October","November","December" ],
    monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
    today: 'Today',
    clear: 'Clear',
    dateFormat: 'mm/dd/yy',
    weekHeader: 'Wk'
  };

  calendarState: boolean = false;

  constructor() { }

  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.value){
      this.calendarValue = this.value ? new Date(this.value) : null;
    }
  }

  onDaySelect(event){
    const formatted = moment(event).format('YYYY-MM-DD')
    this.calendarValue = new Date(formatted);

    const payload = {
      name: this.name,
      formatted
    }

    this.dateChanged.emit(payload);
  }

  changeCalendarState(event){
    if(event != null || event != undefined){
      this.calendarState = event;
    }else{
      this.calendarState = !this.calendarState;
    }
  }

}
